<template>
    <div class="modal-image" v-if="showModal">
        <div class="modal-image-content">
            <span class="close-modal" @click="closeModal">&times;</span>
            <img :src="imageSrc" alt="Image"/>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
        imageSrc: {
            type: String,
            required: true,
        },
    },
    methods: {
        onClickOutsode(e) {
            if (e.target.localName == ".modal-image") {
                this.showModal = false;
                this.$emit("close");
            } else {
            }
        },
        closeModal() {
            this.$emit("close");
        },
    },
    mounted() {
        window.addEventListener("click", this.onClickOutsode);
    },
};
</script>
<style scoped>
img {
    width: 100%;
    height: 100%;
}
.modal-image-content {
    position: absolute;
    width: auto;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
}

.modal-image {
    position: fixed;
    border: 1px solid gray;
    background-color: #000c;
    bottom: 0;
    right: 0;
    top: 0;
    left: 0;
    z-index: 10;

}

.close-modal {
    color: #ccc;
    float: right;
    font-size: 58px;
    font-weight: bold;
    cursor: pointer;
    position: absolute;
    right: 2rem;
}
</style>
